export class MailService {
  public id?: number;
  public mailId: number;
  public serviceId: number;
  public codeService?: string;
  public description?: string;
}
